import React from 'react';
import * as ReactDOM from "react-dom";
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

document.addEventListener('DOMContentLoaded', function (e) {
    // console.log(window.scrollTo);
    if (window.reactContainers) {
        for (let key in window.reactContainers) {
            if (!window.reactContainers.hasOwnProperty(key)) {
                continue;
            }
            let reactContainers = window.reactContainers[key];
            let $getReactElement = document.getElementById(key);

            if (!reactContainers.configs || !window[reactContainers.configs] || !$getReactElement) {
                continue;
            }

            const App = require(`./App/${reactContainers.app}`).default;
            ReactDOM.render(<App config={window[reactContainers.configs]}/>, $getReactElement);
        }
    }
});
